import React from "react";
import { IoKeyOutline } from "react-icons/io5";
import useTranslator from "../../hooks/useTranslator";
import { formatPropertyAddress } from "../../helper/common";
import { Button, Modal, Notice } from "../design";
import "./VacatePropertyModal.css";

const VacatePropertyModal = ({
  show,
  onHide,
  onConfirm,
  isLoading,
  property,
  currentLang,
  hasActiveInsurance,
}) => {
  const { _t } = useTranslator();
  const propertyName =
    formatPropertyAddress(property, currentLang) ||
    property?.address ||
    _t("thisProperty");

  return (
    <Modal
      open={show}
      onClose={onHide}
      dismissible={false}
      id="vacate-property-modal"
      icon={
        <div className="vacate-property-icon">
          <IoKeyOutline />
        </div>
      }
      title={_t("vacateThisProperty")}
      description={
        <>
          {_t("vacating")} <strong>{propertyName}</strong>{" "}
          {_t("willRemoveAllTenantsAndLeavePropertyVacant")}
        </>
      }
      actions={
        <>
          <Button
            variant="secondary"
            size="lg"
            onClick={onHide}
            disabled={isLoading}
          >
            {_t("cancel")}
          </Button>
          <Button
            variant="danger"
            size="lg"
            onClick={onConfirm}
            loading={isLoading}
          >
            {_t("vacateProperty")}
          </Button>
        </>
      }
    >
      {hasActiveInsurance && (
        <Notice
          tone="warning"
          className="vacate-property-notice"
          title={_t("propertyHasActiveNonPaymentInsurance")}
        >
          {_t("vacatingStartsInsuranceReview")}
        </Notice>
      )}
    </Modal>
  );
};

export default VacatePropertyModal;
